import { useState, useMemo, useCallback } from "react";
import { FILTER_TYPES } from "../constants";

/**
 * Hook personalizado para manejar filtros del calendario
 */
export const useCalendarFilters = (events) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const filterOptions = useMemo(() => {
    if (!filterType) return [];

    switch (filterType) {
      case FILTER_TYPES.TECHNICIAN: {
        const names = events
        .map((e) =>
          typeof e.technician === "object"
            ? e.technician?.name
            : e.technician
        )
        .filter(Boolean);
      
        return [...new Set(names)].sort();
      }

      case FILTER_TYPES.ZONE: {
        const zones = events
          .map((e) => e.branch?.city)
          .filter((zone) => zone && zone.trim() !== "")
          .map((zone) => zone.trim());

        return [...new Set(zones)].sort();
      }

      default:
        return [];
    }
  }, [filterType, events]);

  const filteredEvents = useMemo(() => {
    if (!filterType || !filterValue) return events;

    return events.filter((e) => {
      switch (filterType) {
        case FILTER_TYPES.TECHNICIAN:
          const techName =
          typeof e.technician === "object"
            ? e.technician?.name
            : e.technician;
        
        return techName === filterValue;

        case FILTER_TYPES.ZONE:
          return e.branch?.city === filterValue; // city contiene la zona/estado

        default:
          return true;
      }
    });
  }, [events, filterType, filterValue]);

  const clearFilters = useCallback(() => {
    setFilterType("");
    setFilterValue("");
  }, []);

  return {
    filterType,
    filterValue,
    filterOptions,
    filteredEvents,
    setFilterType,
    setFilterValue,
    clearFilters,
  };
};

